import { validateProps } from '../../utils/PropsValidationUtils';
import { isValidBase } from '../BaseEntity';
export function isValidEnrichedContext(enrichedContext) {
  return isValidBase(enrichedContext) && validateProps(enrichedContext, ['entityId', 'context']);
}
//# sourceMappingURL=EnrichedContext.js.map